module.exports = __webpack_public_path__ + "img/zu4.d5e85cb0.png";